import { render, staticRenderFns } from "./CyberRiskAwareLicences.vue?vue&type=template&id=6652a891&"
import script from "./CyberRiskAwareLicences.vue?vue&type=script&lang=js&"
export * from "./CyberRiskAwareLicences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports